import { IEntity } from 'Modules/Entity/types';
import { EnumEntityStatus } from '../../constants/enums';

export enum EntityActionTypes {
  SET_ENTITY = 'SET_ENTITY',
  SET_ENTITY_STATUS = 'SET_ENTITY_STATUS',
}

export interface ISetEntityAction {
  type: EntityActionTypes;
  payload: IEntity;
}

export interface ISetEtnityStatusAction {
  type: EntityActionTypes;
  payload: EnumEntityStatus;
}

export function setEntityAction(payload: IEntity): ISetEntityAction {
  return {
    type: EntityActionTypes.SET_ENTITY,
    payload,
  };
}

export function setEntityStatusAction(payload: EnumEntityStatus): ISetEtnityStatusAction {
  return {
    type: EntityActionTypes.SET_ENTITY_STATUS,
    payload,
  };
}
